import React, { useEffect, useState, useRef, useMemo } from "react";
import style from "../styles.module.scss";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { useSelector, useDispatch } from "react-redux";
import axios from 'util/axios';
import { useTranslation } from "react-i18next";

import Row from "../datatable/DataTable";

import update from "immutability-helper";

import ModalPortal from "util/component/Modal";
import { ConfirmWithMessage, Modal } from "util/component/Modal/Modal";

const post = async ({ api, body, message }, getFunc, onError) => {
    const response = await axios.post(process.env.REACT_APP_API + api, {...body, message});
    if(response.status.toString() === "200") {
        if (response.data.data.result?.toString().includes("ERR")) {
            onError(response.data.data.result.toString());
        } else {
            getFunc && getFunc();
        }
    } else {
        onError("Server Code : " + response.status.toString());
    }
};

const targetColumn = [{ col: "code", readOnly: true }, { col: "cdNm" }];

const CriticalityTable = () => {
    const { t } = useTranslation(["page"]);
    const user = useSelector((store) => store.user);
    const mTable = useSelector((store) => store.masterTable);
    const dispatch = useDispatch();

    const [TableData, SetTableData] = useState([]);

    const [NewParam, SetNewParam] = useState({ code: "", cdNm: "" });

    const ModalMessage = useRef(null);
    const tempData = useRef(null);

    const rendering = mTable.proc === "CRI";

    const [ModalOpen, SetModalOpen] = useState(false);

    const [ Filter, SetFilter ] = useState("");

    const onError = (message) => {
        ModalMessage.current = t(message);
        SetModalOpen("modal");
    }

    const getUnit = async () => {
        const response = await axios.post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", { grcd: mTable.proc });
        const data = response.data.data.result;
        let code;

        try {
            if (data.length < 2) {
                code = data.length + 1;
            } else {
                const codeNum = data.reduce((prev, value) => {
                    return prev.code >= value.code ? prev.code : value.code;
                });
                code = parseInt(codeNum) + 1;
            }
        } catch (e) {
            code = 1;
        }

        if (isNaN(code)) code = 1;

        SetModalOpen(false);
        SetTableData(data);
        SetNewParam({ code: code, cdNm: "" });
        dispatch({ type: "setMaster", name: "uo", value: null });
    };

    const action = (args) => {
        const { type } = args;
        switch (type.toString().toLowerCase()) {
            case "change":
                SetTableData((d) =>
                    update(d, {
                        [args.index]: { $set: { ...d[args.index], ...{ [args.name]: args.value.toString().trim(), isUpdate: true } } },
                    })
                );
                break;
            case "move":
                SetTableData((d) =>
                    update(d, {
                        $splice: [
                            [args.dragIndex, 1],
                            [args.hoverIndex, 0, d[args.dragIndex]],
                        ],
                    })
                );
                break;
            case "select":
                dispatch({ type: "setMaster", name: "uo", value: TableData[args.index].code });
                const fi = TableData.findIndex((v) => v.selected);
                SetTableData((d) =>
                    update(d, {
                        [fi]: { $set: { ...d[fi], selected: false } },
                        [args.index]: { $set: { ...d[args.index], selected: true } },
                    })
                );
                break;
            case "updatecomplete":
                SetTableData((d) => {
                    const next = update(d, {
                        [args.index]: { $set: { ...d[args.index], isUpdate: false } },
                    });
                    tempData.current = {
                        api: "/common/modifyMasterCodeNm",
                        body: {
                            groupCd: mTable.proc,
                            code: next[args.index].code,
                            cdNm: next[args.index].cdNm,
                            userId: user.userId,
                        },
                    };
                    ModalMessage.current = t("modifyConfirm");
                    SetModalOpen("confirm");
                    return next;
                });
                break;
            case "disable":
                tempData.current = {
                    api: "/common/modifyMasterCodeDisableYn",
                    body: {
                        groupCd: mTable.proc,
                        code: TableData[args.index].code,
                        disableYn: TableData[args.index].disableYn === "N" ? "Y" : "N",
                        userId: user.userId,
                    },
                };
                ModalMessage.current = t("statusConfirm");
                SetModalOpen("confirm");
                break;
            default:
                console.error("No type [" + type + "]");
        }
    };

    const insertMasterCode = () => {
        const { code, cdNm } = NewParam;
        if (!!!code || !!!cdNm) {
            ModalMessage.current = t("emptyConfirm");
            SetModalOpen("modal");
        } else {
            let orderBy;

            try {
                if (TableData.length < 2) {
                    orderBy = TableData.length + 1;
                } else {
                    const orderByNum = TableData.reduce((prev, value) => {
                        return prev.orderBy >= value.orderBy ? prev.orderBy : value.orderBy;
                    });
                    orderBy = parseInt(orderByNum) + 1;
                }
            } catch (e) {
                orderBy = 1;
            }

            if (isNaN(orderBy)) orderBy = 1;

            tempData.current = {
                api: "/common/createMasterCode",
                body: {
                    groupCd: mTable.proc,
                    code,
                    cdNm,
                    orderBy,
                    userId: user.userId,
                },
            };
            ModalMessage.current = t("addConfirm");
            SetModalOpen("confirm");
        }
    };

    const renderTable = useMemo(() => {
        let data = [...TableData];
/*        if (!!Filter) {
            data = data.filter((e) => {
                return e["label"].toString().toLowerCase().includes(Filter.toString().toLowerCase());
            });
        }*/
        const row = data.map((v, i) => {
            if(v.label.toString().toLowerCase().includes(Filter.toLowerCase())){
                return <Row key={"unitTable" + i} index={i} disabled={!user.isAdmin}  rowData={v} targetCol={targetColumn} action={action} admin={user.isAdmin} />;
            }
        });
        return row;
    }, [TableData, Filter]);

    useEffect(() => {
        if (rendering) getUnit();
        return () => {
            SetTableData([]);
        };
    }, [mTable.proc, rendering]);

    const ModalRender = useMemo(() => {
        const confirmValid = () => {
            return true;
        };
        const onConfirm = async (message) => {
            await post({...tempData.current, message}, getUnit, onError);
            
        };

        if (!ModalOpen) {
            tempData.current = null;
            return null;
        } else {
            if (ModalOpen === "confirm") {
                return (
                    <ConfirmWithMessage onClose={() => SetModalOpen(false)} valid={confirmValid} onConfirm={(message) => onConfirm(message)}>
                        <p>{ModalMessage.current}</p>
                    </ConfirmWithMessage>
                );
            } else {
                return <Modal onClose={() => SetModalOpen(false)}>{ModalMessage.current}</Modal>;
            }
        }
    }, [ModalOpen]);

    if (!rendering) {
        return <></>;
    } else {
        return (
            <section className={`${style.unitTable}`}>
                <div className={`${style.mainTable}`}>
                    <DndProvider backend={HTML5Backend}>
                        <table>
                            <colgroup>
                                <col width="50px" />
                                <col width="230px" />
                                {
                                    user.isAdmin && <col width="130px" />
                                }
                                
                            </colgroup>
                            <thead style={{ position: "sticky", zIndex: "10", top: "0" }}>
                                <tr>
                                    <th colSpan="3">Criticality</th>
                                </tr>
                                <tr>
                                    <th>Code</th>
                                    <th>Value</th>
                                    {user.isAdmin && <th>Status</th> }
                                    
                                </tr>
                                <tr style={{backgroundColor: "#FFF"}}>
                                    <td colSpan={user.isAdmin ? 3 : 2}>
                                        <input type="text" placeholder="Filter" value={Filter} onChange={(e) => {SetFilter(e.target.value)}} />
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {renderTable}
                            </tbody>
                            {
                                user.isAdmin && <tfoot style={{ position: "sticky", zIndex: "10", bottom: "0px" }}>
                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            readOnly
                                            placeholder="Code"
                                            value={NewParam.code}
                                            onChange={(e) => {
                                                SetNewParam((p) => ({ ...p, code: e.target.value }));
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Unit Name"
                                            value={NewParam.cdNm}
                                            onChange={(e) => {
                                                SetNewParam((p) => ({ ...p, cdNm: e.target.value }));
                                            }}
                                        />
                                    </td>
                                    <td className={`${style.textCenter}`}>
                                        <button className={`${style.tBtn} ${style.main}`} onClick={insertMasterCode}>
                                            {t("save")}
                                        </button>
                                    </td>
                                </tr>
                            </tfoot>
                            }
                            
                        </table>
                    </DndProvider>
                </div>
                {!!ModalOpen && <ModalPortal>{ModalRender}</ModalPortal>}
            </section>
        );
    }
};

export default React.forwardRef(CriticalityTable);
